const isDev = (): boolean => process.env.NODE_ENV === 'development';

const isTest = (): boolean => process.env.NODE_ENV === 'test';

export { isDev, isTest };
